export const PAGINATION_MIN_HEIGHT = 52;
